import { AddPlusButton } from '@components/core-ui/buttons/AddPlusButton';
import { OrganizationTeamResponseDto, OrganizationTeamWithMembersResponseDto } from 'app/API';
import { TeamCard } from './TeamCard';

type TProps = {
  teams: (OrganizationTeamResponseDto | OrganizationTeamWithMembersResponseDto)[];
  handleRemoval: (teamId: string) => void;
  addTeam?: () => void;
};

export function TeamCards({ teams, handleRemoval, addTeam }: TProps) {
  const handleDeleteTeam = (team: TProps['teams'][0]) => {
    handleRemoval(team?.id);
  };

  return (
    <div className="mt-5">
      <ul className="list flex flex-wrap gap-5">
        {teams.map((team) => (
          <TeamCard key={team.id} team={team} handleDeleteTeam={handleDeleteTeam} />
        ))}
        {addTeam && teams.length === 0 ? (
          <li className="col-span-1 flex rounded-md border-tint border-dashed border-2 text-[var(--color-text-subtle)] font-[600] p-4">
            Add a team by clicking &ldquo;+&rdquo; icon on the right side.
          </li>
        ) : null}
        {addTeam ? <AddPlusButton onClick={addTeam} /> : null}
      </ul>
    </div>
  );
}
